import React from 'react';

export function InitMatomo(props) {
  React.useEffect(() => {
    // console.log(window.MonumentEnv);
    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
    var d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0];
    g.async = true;
    var src = 'https://matomo.joinmonument.com/js/container_llUHhJRx.js';
    const branch = window.MonumentEnv?.version?.branch || '';

    if (!branch.startsWith('release-')) {
      console.log('Matomo: Using staging environment');
      src =
        'https://matomo.joinmonument.com/js/container_llUHhJRx_staging_38e8395ef0c9d6ff4d1780e7.js';
    } else {
      console.log('Matomo: Using production environment');
    }

    g.src = src;
    s.parentNode.insertBefore(g, s);

    var waitForTrackerCount = 0;
    function matomoWaitForTracker() {
      if (typeof _paq === 'undefined' || !window.Osano || !window.Osano.cm) {
        if (waitForTrackerCount < 4000) {
          setTimeout(matomoWaitForTracker, 250);
          waitForTrackerCount++;
          return;
        } else {
          console.log('Consent: Gave up');
        }
      } else {
        Osano.cm.addEventListener('osano-cm-initialized', change => {
          consentSet(window.Osano.cm.getConsent());
        });
        Osano.cm.addEventListener('osano-cm-consent-changed', change => {
          consentSet(change);
        });
        Osano.cm.addEventListener('osano-cm-consent-saved', change => {
          consentSet(change);
        });
      }
    }
    function consentSet(change) {
      if (change.hasOwnProperty('ANALYTICS') && change.ANALYTICS === 'ACCEPT') {
        console.log('Consent: Given');
        _paq.push(['setConsentGiven']);
      } else {
        console.log('Consent: Revoked');

        _paq.push(['forgetConsentGiven']);
      }
    }
    matomoWaitForTracker();
  }, []);

  return <>{props.children}</>;
}
